import { render, staticRenderFns } from "./RegistryLockList.vue?vue&type=template&id=0ac8a3b9&"
import script from "./RegistryLockList.vue?vue&type=script&lang=js&"
export * from "./RegistryLockList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports